import React, { Component } from "react";
import moment from "moment";

import { translate, getLanguage } from "../Translation/Translation";

import "./OSDayCardAlt.css";

class OSDayCardAlt extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0 };
    this.selectTrip = this.selectTrip.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentWillReceiveProps(nextProps) {
    const {
      searchStartDay,
      searchEndDay,
      userSelectedDepartureTrip,
      userSelectedReturnTrip
    } = nextProps.data.data.itineraries;
    const { trips, mode, tripDay } = nextProps;

    const cardDay = tripDay.format("YYYY-MM-DD");
    if (mode === "departure") {
      if (searchStartDay === cardDay) {
        if (!userSelectedDepartureTrip) {
          if (trips.length > 0) {
            this.selectTrip(false, trips[0], false);
          }
        }
      }
    }

    if (mode === "arrival") {
      if (searchEndDay === cardDay) {
        if (!userSelectedReturnTrip) {
          if (trips.length > 0) {
            this.selectTrip(false, trips[0], false);
          }
        }
      }
    }
  }

  selectTrip(event, trip, userSelectedTrip) {
    const {
      setSelectedOutgoingTrip,
      setSelectedIncomingTrip,
      setUserSelectedDepartureTrip,
      setUserSelectedReturnTrip
    } = this.props.data.data;
    if (event) {
      event.preventDefault();
    }
    if (this.props.mode === "departure") {
      localStorage.setItem("outgoingTrip", JSON.stringify(trip));
      setSelectedOutgoingTrip(trip);
      if (userSelectedTrip) {
        setUserSelectedDepartureTrip(true);
      }
    } else {
      localStorage.setItem("incomingTrip", JSON.stringify(trip));
      setSelectedIncomingTrip(trip);
      if (userSelectedTrip) {
        setUserSelectedReturnTrip(true);
      }
    }
  }

  render() {
    const { tripDay, trips } = this.props;
    const {
      selectedIncomingTrip,
      selectedOutgoingTrip
    } = this.props.data.data.itineraries;
    const { width } = this.state;
    return (
      <div className="trip-route">
        {width > 1200
          ? trips.map((trip, index) => {
              return (
                <div
                  key={index}
                  className={
                    trip === selectedIncomingTrip ||
                    trip === selectedOutgoingTrip
                      ? "trip-container selected"
                      : "trip-container"
                  }
                >
                  <div className="trip-companyimage-container">
                    <img src={trip.company.imageUrl} />
                  </div>
                  <div className="trip-dateinfo-container">
                    <span className="column-title">
                      {trip.departureLocation.name} -{" "}
                      {trip.arrivalLocation.name}
                    </span>
                    <span className="column-description">
                      {moment(trip.departureDateTime).format("DD/MM/YYYY")}
                    </span>
                  </div>
                  <div className="trip-departureinfo-container">
                    <span className="column-title">Departure</span>
                    <span className="column-description">
                      {moment(trip.departureDateTime).format("HH:mm")}
                    </span>
                  </div>
                  <div className="trip-arrivalinfo-container">
                    <span className="column-title">Arrival</span>
                    <span className="column-description">
                      {moment(trip.arrivalDateTime).format("HH:mm")}
                    </span>
                  </div>
                  <div className="trip-vesselinfo-container">
                    <span className="column-title">Vessel</span>
                    <span className="column-description">
                      {trip.vessel.name}
                    </span>
                  </div>
                  <div className="trip-select-container">
                    <button
                      className={
                        trip === selectedIncomingTrip ||
                        trip === selectedOutgoingTrip
                          ? "trip-select selected"
                          : "trip-select"
                      }
                      onClick={event => this.selectTrip(event, trip, true)}
                    >
                      {trip === selectedIncomingTrip ||
                      trip === selectedOutgoingTrip
                        ? translate(getLanguage(), "Selected")
                        : translate(getLanguage(), "Select")}
                    </button>
                  </div>
                </div>
              );
            })
          : trips.map((trip, index) => {
              return (
                <div
                  key={index}
                  className={
                    trip === selectedIncomingTrip ||
                    trip === selectedOutgoingTrip
                      ? "trip-container selected"
                      : "trip-container"
                  }
                >
                  <div className="trip-route-info">
                    <div className="trip-companyimage-container">
                      <img src={trip.company.imageUrl} />
                    </div>
                    <div className="trip-dateinfo-container">
                      <span className="column-title">
                        {trip.departureLocation.name} -{" "}
                        {trip.arrivalLocation.name}
                      </span>
                      <span className="column-description">
                        {moment(trip.departureDateTime).format("DD/MM/YYYY")}
                      </span>
                    </div>
                  </div>
                  <div className="trip-split">
                    <div className="trip-departureinfo-container">
                      <span className="column-title">Departure</span>
                      <span className="column-description">
                        {moment(trip.departureDateTime).format("HH:mm")}
                      </span>
                    </div>
                    <div className="trip-arrivalinfo-container">
                      <span className="column-title">Arrival</span>
                      <span className="column-description">
                        {moment(trip.arrivalDateTime).format("HH:mm")}
                      </span>
                    </div>
                  </div>
                  <div className="trip-split">
                    <div className="trip-vesselinfo-container">
                      <span className="column-title">Vessel</span>
                      <span className="column-description">
                        {trip.vessel.name}
                      </span>
                    </div>
                    <div className="trip-select-container">
                      <button
                        className={
                          trip === selectedIncomingTrip ||
                          trip === selectedOutgoingTrip
                            ? "trip-select selected"
                            : "trip-select"
                        }
                        onClick={event => this.selectTrip(event, trip, true)}
                      >
                        {trip === selectedIncomingTrip ||
                        trip === selectedOutgoingTrip
                          ? translate(getLanguage(), "Selected")
                          : translate(getLanguage(), "Select")}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    );
  }
}

export default OSDayCardAlt;



// WEBPACK FOOTER //
// ./src/components/OSDayCardAlt/OSDayCardAlt.js